// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"UsersPage_pageContainer__fE9cs","secondaryPageContainer":"UsersPage_secondaryPageContainer__3xPHU"};